// removed by extract-text-webpack-plugin
module.exports = {"fails":"_3y6r1AlFhMIGNholRLc4Xs","view":"_20qTnJZhGzMWnP3Nam6r_U","Icon":"w7ftGFxPfUGn79zzfn01y","Title":"_1NrSwZCuyR7rFxnBnQ635d","Title2":"_3EtIcZZ9_dR5ZQ_LSblGvZ","button":"_3gReeXIocPFyhflR5bV4iX"};


//////////////////
// WEBPACK FOOTER
// ./src/App/Pages/Documents/MassiveDactilar/styles.css
// module id = 2742
// module chunks = 0